import React from 'react';

const EditIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#F2F8FD" />
      <path
        d="M20 6H12C8 6 6 8 6 12V25C6 25.55 6.45 26 7 26H20C24 26 26 24 26 20V12C26 8 24 6 20 6ZM15.11 20.66C14.86 20.91 14.4 21.14 14.06 21.19L11.98 21.48C11.9 21.49 11.82 21.5 11.75 21.5C11.4 21.5 11.08 21.38 10.85 21.15C10.57 20.87 10.45 20.46 10.52 20.02L10.81 17.94C10.86 17.6 11.09 17.13 11.34 16.89L15.11 13.12C15.17 13.3 15.25 13.48 15.34 13.68C15.43 13.86 15.52 14.04 15.62 14.21C15.7 14.35 15.79 14.49 15.87 14.59C15.97 14.74 16.07 14.87 16.14 14.94C16.18 15 16.22 15.04 16.23 15.06C16.45 15.31 16.68 15.55 16.9 15.73C16.96 15.79 17 15.82 17.01 15.83C17.14 15.93 17.26 16.04 17.38 16.11C17.51 16.21 17.65 16.3 17.79 16.38C17.96 16.48 18.14 16.58 18.33 16.67C18.52 16.76 18.7 16.83 18.88 16.89L15.11 20.66ZM20.55 15.23L19.77 16.01C19.72 16.06 19.65 16.09 19.58 16.09C19.56 16.09 19.52 16.09 19.5 16.08C17.78 15.59 16.41 14.22 15.92 12.5C15.89 12.41 15.92 12.31 15.99 12.24L16.78 11.45C18.07 10.16 19.29 10.19 20.55 11.45C21.19 12.09 21.51 12.71 21.5 13.35C21.5 13.98 21.19 14.59 20.55 15.23Z"
        fill="#333333"
      />
    </svg>
  );
};

export default EditIcon;
